import React from "react";
import type {FunctionComponent} from "react";
import {WhenDevice} from "../../../../modules/conditional/when-device/WhenDevice";


export interface IWhenDeviceTypeDesktop{
  not?: boolean;
}

export const WhenDeviceTypeDesktop: FunctionComponent<IWhenDeviceTypeDesktop> = ({children, not}) => {
  if (!!not){
    return <WhenDevice blockedType={'desktop'}>{children}</WhenDevice>;
  }
  return <WhenDevice allowedType={'desktop'}>{children}</WhenDevice>;
}
